import { SKOLKO_STOIT_POST } from "./skolko-stoit-rasshifrovka-chasa-zapisi";
import { TOCHNOST_RASSHIFROVKI_POST } from "./tochnost-rasshifrovki-99-procentov";
import { TOP_SERVISY_POST } from "./top-servisy-transkribacii";
import type { BlogPostConfig } from "./types";

export type { BlogPostConfig } from "./types";

/**
 * Опубликованные статьи. Первым заходом выпускаем листикл и разбор цены:
 * 21 страница уже висит «обнаружена, не проиндексирована», и пачка новых URL
 * встанет в ту же очередь — сначала смотрим, зайдут ли эти две.
 *
 * `tochnost-rasshifrovki-99-procentov` — канон статьи 1 с vc.ru (канал закрыт
 * 09.09, версия на vc не индексируется, дубля не создаём). Это единственная
 * статья с собственными замерами точности, поэтому её ценность не в трафике
 * по шаблонному запросу, а в том, что на неё можно ссылаться как на источник.
 *
 * Черновики намеренно НЕ импортируются: статический импорт затащил бы их текст
 * в общий JS-чанк, и неопубликованные статьи читались бы прямо из бандла.
 * Чтобы выпустить статью — добавить импорт сюда и убрать `draft: true` в её файле.
 *
 * Ждут публикации: kak-skachat-video-iz-vk, transkribaciya-pesni-v-tekst,
 * protokol-vstrechi-iz-zapisi, kakoy-format-zapisi-luchshe-dlya-raspoznavaniya,
 * rasshifrovka-sozvona-v-teams.
 */
const IMPORTED_POSTS: BlogPostConfig[] = [TOP_SERVISY_POST, SKOLKO_STOIT_POST, TOCHNOST_RASSHIFROVKI_POST];

/**
 * Второй рубеж: даже при случайно добавленном импорте статья с `draft: true`
 * не попадёт ни в роуты, ни в хаб, ни в sitemap, ни в llms.txt.
 */
export const BLOG_POSTS: BlogPostConfig[] = IMPORTED_POSTS.filter(post => !post.draft);
